import { IconButton } from '@components/IconButton';
import {
  IconAdd,
  IconSearch,
  IconClear,
  IconFilter,
  IconMail,
  IconLogout,
  IconArrowForward,
  IconArrowDown,
  IconLightning,
} from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const IconButtonSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Icon Button"
      description="Icon-only buttons for compact actions. Available in two variants (Tertiary & Outlined) and three sizes."
      figmaNodeId="271-1679"
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Tertiary (Default) - All Sizes</h3>
      <div className={styles.row}>
        <div className={styles.iconButtonDemo}>
          <IconButton size="large" aria-label="Add item">
            <IconAdd size={20} />
          </IconButton>
          <span className={styles.iconButtonLabel}>Large (38px)</span>
        </div>
        <div className={styles.iconButtonDemo}>
          <IconButton size="medium" aria-label="Search">
            <IconSearch size={18} />
          </IconButton>
          <span className={styles.iconButtonLabel}>Medium (32px)</span>
        </div>
        <div className={styles.iconButtonDemo}>
          <IconButton size="small" aria-label="Clear">
            <IconClear size={14} />
          </IconButton>
          <span className={styles.iconButtonLabel}>Small (24px)</span>
        </div>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Outlined - All Sizes</h3>
      <div className={styles.row}>
        <div className={styles.iconButtonDemo}>
          <IconButton variant="outlined" size="large" aria-label="Add item">
            <IconAdd size={20} />
          </IconButton>
          <span className={styles.iconButtonLabel}>Large (38px)</span>
        </div>
        <div className={styles.iconButtonDemo}>
          <IconButton variant="outlined" size="medium" aria-label="Search">
            <IconSearch size={18} />
          </IconButton>
          <span className={styles.iconButtonLabel}>Medium (32px)</span>
        </div>
        <div className={styles.iconButtonDemo}>
          <IconButton variant="outlined" size="small" aria-label="Clear">
            <IconClear size={14} />
          </IconButton>
          <span className={styles.iconButtonLabel}>Small (24px)</span>
        </div>
      </div>
      <p className={styles.hint}>Outlined variant has a 1px grey border.</p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Various Icons</h3>
      <div className={styles.row}>
        <IconButton aria-label="Filter">
          <IconFilter size={18} />
        </IconButton>
        <IconButton aria-label="Email">
          <IconMail size={18} />
        </IconButton>
        <IconButton aria-label="Logout">
          <IconLogout size={18} />
        </IconButton>
        <IconButton aria-label="Navigate forward">
          <IconArrowForward size={18} />
        </IconButton>
        <IconButton aria-label="Expand">
          <IconArrowDown size={18} />
        </IconButton>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Disabled State</h3>
      <div className={styles.row}>
        <IconButton size="large" aria-label="Disabled large" disabled>
          <IconAdd size={20} />
        </IconButton>
        <IconButton variant="outlined" size="large" aria-label="Disabled outlined" disabled>
          <IconAdd size={20} />
        </IconButton>
        <IconButton size="medium" aria-label="Disabled medium" disabled>
          <IconSearch size={18} />
        </IconButton>
        <IconButton size="small" aria-label="Disabled small" disabled>
          <IconClear size={14} />
        </IconButton>
      </div>
      <p className={styles.hint}>Disabled buttons have reduced opacity and no hover effect.</p>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Interactive Demo</h3>
      <div className={styles.row}>
        <IconButton aria-label="Show alert" onClick={() => alert('IconButton clicked!')}>
          <IconLightning size={18} />
        </IconButton>
      </div>
      <p className={styles.hint}>Click the button to trigger an action.</p>
    </div>
  </section>
);
